var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"search-input",attrs:{"placeholder":_vm.$t('common.search'),"background-color":"secondary","append-icon":_vm.value ? undefined : 'mdi-magnify',"solo":"","hide-details":"","clearable":""},on:{"input":_vm.search},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }